import React from 'react';
import { ButtonPrimary, ButtonSecondaryOutlinedGray } from '../../../common/buttonsComponents';
import { ButtonRow, SearchButtonContainer, SearchTooltip } from './FilterActions.styles';

export const FilterActions = ({ isSearchPending, onReset, onSearch, pagination }) => {
  return (
    <ButtonRow>
      {pagination}
      <ButtonSecondaryOutlinedGray $size="small" onClick={onReset}>
        Reset all
      </ButtonSecondaryOutlinedGray>
      <SearchButtonContainer>
        <ButtonPrimary $size="small" onClick={onSearch}>
          Search
        </ButtonPrimary>
        {isSearchPending && <SearchTooltip>To apply new filters, click Search</SearchTooltip>}
      </SearchButtonContainer>
    </ButtonRow>
  );
};
